<rotec-modal-v2 [title]="title" [width]="width" [darkMode]="true" [disablePaddingMainPart]="true">
  <ng-container ngProjectAs="modal-main">
    <div class="add-machine__search-input">
      <rotec-text-input-v2
        placeholder="Search"
        icon="search"
        clearIcon="close"
        (valueChange)="filterMachineOptions($event)"
      ></rotec-text-input-v2>
    </div>
    <div class="add-machine__list">
      @if (!(isLoading$ | async)) {
        <rotec-radio-group-v2
          [options]="filteredMachineOptions || machineOptions"
          [selected]="true"
          [darkMode]="true"
          (selectedChange)="selectMachine($event)"
        ></rotec-radio-group-v2>
      } @else {
        <rotec-spinner-overlay [fixed]="false"></rotec-spinner-overlay>
      }
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <div class="machine-modal-buttons">
      <button rotec-button-secondary dark (click)="close()">
        {{ 'Cancel' | translate }}
      </button>
      <button rotec-button-active (click)="apply()">
        {{ 'Apply' | translate }}
      </button>
    </div>
  </ng-container>
</rotec-modal-v2>
